var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-form-generator',{attrs:{"schema":_vm.expandedSchema,"model":_vm.localModel,"options":_vm.formOptions},on:{"validated":_vm.onValidated,"model-updated":_vm.onUpdated}})}
var staticRenderFns = []

export { render, staticRenderFns }